import { render } from "./index.vue?vue&type=template&id=2abcd9f2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2abcd9f2&lang=less&scoped=true"

import exportComponent from "E:\\MySite\\XuDAQMS\\xudaqms-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2abcd9f2"]])

export default __exports__